<template lang="pug">
  select(v-model="model")
    option
    option(value="Pessoa Física") Pessoa Física
    option(value="Pessoa Jurídica") Pessoa Jurídica
</template>

<script>
export default {
  props: { value: { type: String } },
  computed: {
    model: {
      set(v) {
        this.$emit('input', v)
      },
      get() {
        return this.value
      },
    },
  },
}
</script>
